const messageInformationStore = {

  state: {
    messageInformation: {
      image: null,
      message: null
    }
  },
  mutations: {
    setMessageInformation (state, informationMsg) {
      state.messageInformation = informationMsg
    }
  },

  actions: {

  },

  getters: {
    messageInformation: state => state.messageInformation
  }

}
export default messageInformationStore
